import type { AssessmentResultData } from './types/assessment/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useDisciplineStore } from '@entities/customer/@x/assessment'

import { useAssessmentResultStore } from './assessment-result-store'

interface AssessmentResultReturn {
  initAssessmentResult: (data: AssessmentResultData) => void
}

export const useAssessmentResult = (): AssessmentResultReturn => {
  const assessmentResultStore = useAssessmentResultStore()
  const disciplineStore = useDisciplineStore()

  const initAssessmentResult = (data: AssessmentResultData): void => {
    const isComprehension = data.comprehension_check_up || false
    const assessmentUrls = data.assessment_urls || { math: null, ela: null }

    assessmentResultStore.setAssessmentId(data.id || null)
    assessmentResultStore.setQuestions(data.data || [])
    assessmentResultStore.setScore(data.score || 0)
    assessmentResultStore.setComprehension(isComprehension)
    assessmentResultStore.setAssessmentUrls(assessmentUrls)
    assessmentResultStore.setVariant(disciplineStore.getDisciplineCode || Discipline.Math)
  }

  return {
    initAssessmentResult,
  }
}
